import { gsap } from "gsap";
// import { Draggable } from "gsap/Draggable";
import { Draggable } from "gsap/all";

gsap.registerPlugin(Draggable);

export function blockWheelSlider() {
  const sliders = document.querySelectorAll(".blockWheelSlider");

  sliders.forEach((slider) => {
    const container = slider.querySelector(".blockWheelSlider__collection");
    const list = slider.querySelector(".blockWheelSlider__list");
    const items = Array.from(slider.querySelectorAll(".blockWheelSlider__item"));
    const total = items.length;

    if (total === 0) return;

    const radius = 1200;
    const getSpacing = () => window.innerWidth < 768 ? 337 : 450;
    const dragResistance = 1;
    
    const proxy = document.createElement("div");
    
    let currentX = 0;
    gsap.set(proxy, { x: 0 });

    function update() {
      const isMobile = window.innerWidth < 768;
      const spacing = getSpacing();
      currentX = gsap.getProperty(proxy, "x");

      items.forEach((item, i) => {
        let itemX = i * spacing + currentX;
        
        const wrapWidth = total * spacing;
        itemX = gsap.utils.wrap(-wrapWidth / 2, wrapWidth / 2, itemX);

        let x, y, rotation;

        if (isMobile) {
          x = itemX;
          y = 0;
          rotation = 0;
        } else {
          const angle = itemX / radius;
          x = Math.sin(angle) * radius;
          y = (radius - Math.cos(angle) * radius);
          rotation = angle * (180 / Math.PI);
        }

        const distance = Math.abs(itemX);
        // const scale = gsap.utils.mapRange(0, wrapWidth / 2, 1, 0.7, distance);
        const scale = 1;
        const opacity = 1;

        gsap.set(item, {
          x: x,
          y: y,
          rotation: rotation,
          scale: scale,
          opacity: opacity,
          zIndex: Math.round(100 - distance / 10),
          force3D: true
        });

        // Add class for active item
        if (distance < spacing / 2) {
            item.classList.add('is-active');
        } else {
            item.classList.remove('is-active');
        }
      });
    }

    update();

    Draggable.create(proxy, {
      type: "x",
      trigger: container,
      inertia: true,
      onDrag: update,
      onThrowUpdate: update,
      onDragEnd: function() {
          const spacing = getSpacing();
          const snappedX = Math.round(this.x / spacing) * spacing;
          gsap.to(proxy, {
              x: snappedX,
              duration: 0.5,
              ease: "power2.out",
              onUpdate: update
          });
      }
    });

    // Resize handling
    window.addEventListener('resize', update);
  });
}
